import React from 'react'

const ModalBody = (props) => {
    return (
        <div className="relative px-6 pt-1 pb-5 flex-auto min-h-0 overflow-y-auto text-sm text-gray-600 leading-5">
            {props.children}
        </div>
    )
}

export default ModalBody